import Vue from 'vue'
import Vuetify, { VCol, VIcon, VRow } from 'vuetify/lib'

Vue.use(Vuetify, {
  components: {
    VCol,
    VIcon,
    VRow
  }
})

export default new Vuetify({
  theme: {
    dark: window.localStorage.getItem('dark') === 'true',
    themes: {
      light: {
        primary: '#69b3e7',
        accent: '#fa7268'
      },
      dark: {
        primary: '#69b3e7',
        accent: '#fa7268'
      }
    }
  }
})
